/* eslint-disable react-hooks/exhaustive-deps */
import styles from "./VoiceCallButton.module.css"
import {ReactComponent as DialerIcon} from "./dialer.svg"
import {Auth} from "types/auth"
import {useCallback, useContext} from "react"
import {VoiceCallContext} from "context/VoiceCallContext"
import {getFullName, toastInfo} from "helpers"
import cx from "classnames"
import {DialerStudent} from "types/auto-dialer"
import {getDefaultOrFirstProfile} from "helpers/task"

type Props = {
    dialerId?: number
    studentProfileId?: number
    studentData?: Auth.UserProfile
    departmentId?: number
}

export function VoiceCallButton({dialerId, studentData, departmentId, studentProfileId}: Props) {
    const {calling, startCall, onEndedCallback} = useContext(VoiceCallContext)

    const phone = studentData?.phones.filter((p) => p.isPrimary)[0]?.corrected_phone
    const email = studentData?.emails.filter((e) => e.isPrimary)[0]?.email
    const profile = getDefaultOrFirstProfile(studentData, Auth.UserProfileType.Student)
    const studentInfo: DialerStudent = {
        userId: studentData?.id,
        profileId: studentProfileId,
        fullName: getFullName(studentData),
        email,
        phone,
        campusName: profile?.campus,
        dialerId
    }

    const handleStartCall = useCallback(() => {
        if (calling) return
        if (!studentInfo.phone) {
            return toastInfo("This student has no phone number")
        }
        startCall(studentInfo, departmentId)
        onEndedCallback(null)
    }, [calling, studentInfo, departmentId, startCall])

    return (
        <div className={cx(styles.btnWrap, {[styles.disabled]: calling})} onClick={handleStartCall}>
            <DialerIcon className={styles.icon} />
            <span className={styles.title}>Voice Call</span>
        </div>
    )
}
